import React, { Component, Fragment } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import ToastrContainer from 'react-toastr-basic'

import './App.css';
import './scss/style.css'

import { Full } from './containers';
import { Login } from './views/framework/Pages';
import AuthenticatedRoute from './helpers/authentication/AuthenticatedRoute'

class App extends Component {
  render() {
    return (
      <Fragment>
        <ToastrContainer />
        <HashRouter>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route path="/" name="Home" component={() => <AuthenticatedRoute component={<Full/>}/>} />
          </Switch>
        </HashRouter>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js